import type { IntlShape } from 'react-intl'

import type { definitions } from '@luxuryescapes/contract-trip'

export type PublicAccommodationPricing = definitions['accommodationPricingPublic']

export type AccommodationUnavailableReason = NonNullable<PublicAccommodationPricing['unavailableReason']>

export interface DisplayPricing {
  price?: number
  luxPlusPrice?: number
  value?: number
  discountPercent?: number
  memberDiscountPercent?: number
  currencyCode?: string
}

export const displayPricingFromDTO = (pricing: PublicAccommodationPricing): DisplayPricing => ({
  price: pricing.amount,
  luxPlusPrice: pricing.memberAmount,
  value: pricing.value,
  discountPercent: pricing.discountPercent,
  memberDiscountPercent: pricing.memberDiscountPercent,
  currencyCode: pricing.currencyCode,
})

export const isTotalMode = (mode: PublicAccommodationPricing['mode']): boolean =>
  mode === 'selected_rate'

export const includesTaxesAndFees = (pricing: PublicAccommodationPricing): boolean =>
  pricing.amountIncludes === 'all_in'

export const pricingUnavailableReason = (
  pricing?: PublicAccommodationPricing,
): AccommodationUnavailableReason | undefined =>
  pricing != null && pricing.amount === undefined ? pricing.unavailableReason ?? 'unavailable' : undefined

export const getAccommodationUnavailableLabel = (
  reason: AccommodationUnavailableReason,
  intl: IntlShape,
): string =>
  reason === 'sold_out'
    ? intl.formatMessage({
        id: '5qRgRGxub1Uhedt_JSwD',
        defaultMessage: 'Sold Out',
        description: 'Label shown when a hotel tile is sold out in the trip planner AI chat',
      })
    : intl.formatMessage({
        id: '3tjsFVSoCaUB1fkmuBtg',
        defaultMessage: 'Price unavailable',
        description: 'Label shown when hotel tile pricing is unavailable in the trip planner AI chat',
      })
